import { createFetcher } from './Fetcher';

export default createFetcher(({ subscriptionStore }) => ({
    fetch: () => subscriptionStore.fetchPrices(),
    cache: !!subscriptionStore.pricesByCurrency,
    isLoading: subscriptionStore.fetchPrices.pending || subscriptionStore.reactivate.pending,
}));
